import styled from "styled-components";

const Container = styled.div`
  margin: 0.5rem 0;
`;

export { Container };
